
import React from 'react';
import { RootObject, } from './type';
import './style.less'

const ActiveList = ({ onlineData }: { onlineData: RootObject }) => {
    return (
        <div className="list-map">
            <div className="list-div-sel">

                <div className="list-word">{onlineData.text}</div>
                <div className="list-tag">{onlineData.cls_label}</div>
                <div className="list-operation">
                    {onlineData?.category ?? ''}
                </div>

            </div>

        </div>
    );
};

export default ActiveList;
